module.exports = "/_next/static/files/a864213e1b086cbe49c4bddae1e39d0a.png";